<script>
import SvgIcon from "@/icons/localSvg.vue";
import addview from './add.vue'
import {registerUser, userPortraitOptions} from '@/api/login'
import {partlist} from "@/api/organize";

export default {
  components: {
    SvgIcon,
    addview
  },
  data() {
    return {
      image: require('../../assets/image/none.png'),
      tablist: [
        {id: 1, name: '1.注册信息'},
        {id: 2, name: '2.员工画像'}
      ],
      tabactive: 1,
      lefttab: [
        {id: 1, name: '岗位信息', show: true, add: '', md: 'section1', isActive: true},
        {id: 2, name: '基本信息', show: true, add: '', md: 'section2', isActive: false},
        {id: 3, name: '家庭关系', show: true, add: '添加成员', md: 'section3', isActive: false},
        {id: 4, name: '紧急联系人', show: true, add: '添加联系人', md: 'section4', isActive: false},
        {id: 5, name: '教育经历', show: true, add: '添加教育经历', md: 'section5', isActive: false},
        {id: 6, name: '培训经历', show: true, add: '添加培训经历', md: 'section6', isActive: false},
        {id: 7, name: '职称信息', show: true, add: '添加职称', md: 'section7', isActive: false},
        {id: 8, name: '工作经历', show: true, add: '添加工作经历', md: 'section8', isActive: false}
      ],
      tableData: [{}, {}],
      sexlist: [
        {id: 1, name: '男'},
        {id: 2, name: '女'}
      ],
      WorkShow: false,
      formdata: {
        name: '',//用户名
        mobile: '',//手机号
        email: '',//电子邮箱
        branch_ids: '',//部门
        job_info: {
          job_name: '',//岗位名称,
          job_type: '',//岗位类别
          come_time: '',//到岗日期
          annual_leave: '',//本年度年假
          job_start_time: '',//累计工龄开始日期
          start_work_time: '',//才加工作时间
          in_company_time: ''//加入本企业时间
        },
        base_info: {
          old_name: '',//曾用名
          birthday: '',//出生日期
          sex: '',//1、男，2、女
          age: '',//年龄
          nation: '',//民族
          birth_location: '',//出生地
          native_place: '',//籍贯
          card_num: '',//身份证号
          present_address: '',//现住址
          contact_address: '',//有效联系地址
          present_address_code: '',//现住址邮政编码
          contact_address_code: '',//有效地址邮政编码
          residence: '',//户口地址
          politics_status: '',//政治面貌
          marriage_status: '',//婚姻状态
          politics_time: '',//政治面貌加入时间
          marriage_time: '',//婚姻登记时间
          politics_location: '',//政治面貌加入地点
          childs_num: '',//子女数目
          introducer: '',//介绍人
        },
        //家庭关系
        family_info: [
          // {
          //   name: '',//成员姓名
          //   relation: '',//与本人关系
          //   sex: '',//性别
          //   politics_status: '',//政治面貌
          //   marriage_status: '',//婚否
          //   work_unit: '',//工作单位
          //   work_location: '',//工作地点
          //   job: '',//职务
          //   location: '',//详细地址
          //   post_code: '',//邮编
          //   phone: '',//联系电话
          //   show: true,
          //   showOne: true
          // }
        ],
        emergency_contact: [
          // {
          //   contact_person:'',//联系人
          //   relation:'',//与本人关系
          //   phone_one:'',//电话1
          //   phone_two:'' ,//电话2
          //   show: true,
          //   showOne: true
          // }
        ],
        //教育经历
        edu: [
          // {
          //   type:'',//教育类型
          //   form:'',//教育形式
          //   start_time:'',//起始日期
          //   end_time:'',//起始日期
          //   school:'',//学校名称
          //   profession:'',//专业名称
          //   finish_school:'',//毕业类型
          //   time:[],
          //   show: true,
          //   showOne: true
          // }
        ],

        train: [
          // {
          //   type:'',//培训类型
          //   institution:'',//培训机构
          //   location:'',//地点
          //   start_time:'',//起始日期
          //   end_time:'',//起始日期
          //   class:'',//培训课程
          //   has_certificate:'',//是否取证
          //   certificate:'',//证书
          //   amount:'',//培训金额
          //   deadline:'',//协议期限
          //   time:[],
          //   show: true,
          //   showOne: true
          // }
        ],
        //职称信息
        job_title: [
          // {
          //   title:'',//职业名称
          //   series:'',//职称系列
          //   level:'',//职称等级
          //   code_num:'',//证书编号
          //   effective_time:'',//生效时间
          //   organ:'',//发证机关
          //   show: true,
          //   showOne: true
          // }
        ],
        //职业资格
        job_qualification: [
          // {
          //   title:'',//资格名称
          //   level:'',//资格等级
          //   code_num:'',//证书编号
          //   send_time:'',//发证时间
          //   send_organ:'',//发证机关
          //   end_time:'',//有效截止时间
          //   show: true,
          //   showOne: true
          // }
        ],
        work_info: []
      },
      formdataback: {
        family_info: [],
        emergency_contact: [],
        edu: [],
        train: [],
        job_title: [],
        job_qualification: [],
      },
      work_index: '',
      work_form: {},
      JobList: [],
      CompanyList: [],
      options: [],
      branch_ids:''
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    this.getuserPortraitOptions()
    this.getpartlist()
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {


    getpartlist() {
      partlist().then(res => {
        if (res.code === 200) {
          this.options = res.data
        }
      })
    },
    getuserPortraitOptions() {
      userPortraitOptions().then(res => {
        if (res.code === 200) {
          this.JobList = res.data.find(item => item.title === '岗位类别').value;
          this.CompanyList = res.data.find(item => item.title === '公司行业').value;
        }
      })
    },
    getNameById(id) {
      const sex = this.sexlist.find(item => item.id === id);
      return sex ? sex.name : null;  // 如果找不到对应的 id，返回 null
    },
    goFH() {

      this.$emit('fh')
    },
    itemShow(index) {
      this.lefttab[index].show = !this.lefttab[index].show
    },
    goReg(id) {
      // 获取目标元素
      const element = document.getElementById(id);

      // 如果元素存在，执行平滑滚动
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start' // 使目标元素对齐到视口的顶部
        });
      }
    },
    handleScroll() {
      // 获取所有 .right-item 元素
      const items = document.querySelectorAll('.right-item');
      let isActiveSet = false;  // 用来标记是否有一个元素已被激活

      items.forEach((item, index) => {
        const rect = item.getBoundingClientRect();

        // 判断元素是否在视口内
        if (rect.top >= 0 && rect.top <= window.innerHeight) {
          // 如果当前没有元素被激活，激活当前元素
          if (!isActiveSet) {
            this.lefttab[index].isActive = true;
            isActiveSet = true;  // 标记一个元素已经被激活
          } else {
            this.lefttab[index].isActive = false;  // 其他元素保持不活跃
          }
        } else {
          this.lefttab[index].isActive = false;  // 元素不在视口中时，保持不活跃
        }
      });
    },
    addPublic(index) {
      if (index === 2) {
        let data = {
          name: '',//成员姓名
          relation: '',//与本人关系
          sex: '',//性别
          politics_status: '',//政治面貌
          marriage_status: '',//婚否
          work_unit: '',//工作单位
          work_location: '',//工作地点
          job: '',//职务
          location: '',//详细地址
          post_code: '',//邮编
          phone: '',//联系电话
          show: true,
          showOne: true
        }
        this.formdata.family_info.push(data)
        console.log('添加成员')
      }
      if (index === 3) {
        let data = {
          contact_person: '',//联系人
          relation: '',//与本人关系
          phone_one: '',//电话1
          phone_two: '',//电话2
          show: true,
          showOne: true
        }
        this.formdata.emergency_contact.push(data)
        console.log('添加联系人')
      }
      if (index === 4) {
        let data = {
          type: '',//教育类型
          form: '',//教育形式
          start_time: '',//起始日期
          end_time: '',//起始日期
          school: '',//学校名称
          profession: '',//专业名称
          finish_school: '',//毕业类型
          time: [],
          show: true,
          showOne: true
        }
        this.formdata.edu.push(data)
        console.log('添加教育经历')
      }
      if (index === 5) {
        let data = {
          type: '',//培训类型
          institution: '',//培训机构
          location: '',//地点
          start_time: '',//起始日期
          end_time: '',//起始日期
          class: '',//培训课程
          has_certificate: '',//是否取证
          certificate: '',//证书
          amount: '',//培训金额
          deadline: '',//协议期限
          time: [],
          show: true,
          showOne: true
        }
        this.formdata.train.push(data)
        console.log('添加培训经历')
      }
      if (index === 6) {
        let data = {
          title: '',//职业名称
          series: '',//职称系列
          level: '',//职称等级
          code_num: '',//证书编号
          effective_time: '',//生效时间
          organ: '',//发证机关
          show: true,
          showOne: true
        }
        this.formdata.job_title.push(data)
        console.log('添加职称')
      }
      if (index === 7) {
        this.work_index = ''
        this.work_form = {}
        console.log('添加工作经历')
        this.WorkShow = true
      }
    },
    addworkin() {
      let data = {
        title: '',//资格名称
        level: '',//资格等级
        code_num: '',//证书编号
        send_time: '',//发证时间
        send_organ: '',//发证机关
        end_time: '',//有效截止时间
        show: true,
        showOne: true
      }
      this.formdata.job_qualification.push(data)
      console.log('添加职业资格')
    },
    WorkSave(data) {
      console.log('this.work_index', this.work_index)
      if (Number.isFinite(this.work_index)) {
        this.formdata.work_info[this.work_index] = data
      } else {
        console.log('添加工作经历data', data)
        this.formdata.work_info.push(data)
      }
      this.WorkShow = false
    },
    editWork(index, row) {
      this.work_index = index
      this.work_form = JSON.parse(JSON.stringify(row))
      console.log('编辑工作经历')
      this.WorkShow = true
    },
    tabactivenext() {
      if (!this.formdata.name) {
        this.$message.error('请输入用户名')
        return
      }
      if (!this.formdata.mobile) {
        this.$message.error('请输入手机号')
        return
      }
      // 手机号格式正则表达式（假设为中国手机号）
      const phoneRegex = /^1[3-9]\d{9}$/;
      if (!phoneRegex.test(this.formdata.mobile)) {
        this.$message.error('请输入正确的手机号');
        return;
      }


      if (!this.formdata.email) {
        this.$message.error('请输入邮箱')
        return
      }
      // 邮箱格式正则表达式
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!emailRegex.test(this.formdata.email)) {
        this.$message.error('请输入正确的邮箱');
        return;
      }
      this.tabactive = 2
    },
    handletabsave(arrname, index) {
      // 定义字段映射数组
      const fields = ['family_info', 'emergency_contact', 'edu', 'train', 'job_title', 'job_qualification'];

      if (fields.includes(arrname)) {
        const field = this.formdata[arrname]; // 获取当前字段的数组
        const fieldBack = this.formdataback[arrname]; // 获取备份数据

        // 设置字段的 show 和 showOne 为 false
        field[index].show = false;
        field[index].showOne = false;

        // 将当前字段数据深拷贝到备份数据
        this.$set(fieldBack, index, JSON.parse(JSON.stringify(field[index])));
      }


    },
    handletabclose(arrname, index) {
      // 定义字段映射数组，避免重复编写条件判断
      const fields = ['family_info', 'emergency_contact', 'edu', 'train', 'job_title', 'job_qualification'];
      if (fields.includes(arrname)) {
        const field = this.formdata[arrname]; // 获取当前字段的数组
        const fieldBack = this.formdataback[arrname]; // 获取备份数据

        if (field[index].showOne) {
          // 如果 showOne 为 true，直接删除
          field.splice(index, 1);
        } else {
          // 否则恢复为备份数据
          this.$set(field, index, JSON.parse(JSON.stringify(fieldBack[index])));
        }
      }

    },
    handletabdel(arrname, index) {
      // 定义一个字段映射数组
      const fields = ['family_info', 'emergency_contact', 'edu', 'train', 'job_title', 'job_qualification'];

      if (fields.includes(arrname)) {
        // 利用动态数组属性名进行操作
        this.formdata[arrname].splice(index, 1);
        this.formdataback[arrname].splice(index, 1);
      }
    },
    handletabedit(arrname, index) {

      // 定义一个映射，简化条件判断
      const fields = ['family_info', 'emergency_contact', 'edu', 'train', 'job_title', 'job_qualification'];
      if (fields.includes(arrname)) {
        // 利用对象映射进行统一处理
        this.formdataback[arrname][index] = JSON.parse(JSON.stringify(this.formdata[arrname][index]));
        this.formdata[arrname][index].show = true;
      }

    },
    removeShowOneData(formdata) {
      // 确保每个数组存在再进行过滤操作
      formdata.family_info = Array.isArray(formdata.family_info) ? formdata.family_info.filter(item => !item.showOne) : [];
      formdata.emergency_contact = Array.isArray(formdata.emergency_contact) ? formdata.emergency_contact.filter(item => !item.showOne) : [];
      formdata.edu = Array.isArray(formdata.edu) ? formdata.edu.filter(item => !item.showOne) : [];
      formdata.train = Array.isArray(formdata.train) ? formdata.train.filter(item => !item.showOne) : [];
      formdata.job_title = Array.isArray(formdata.job_title) ? formdata.job_title.filter(item => !item.showOne) : [];
      formdata.job_qualification = Array.isArray(formdata.job_qualification) ? formdata.job_qualification.filter(item => !item.showOne) : [];

      return formdata;
    },


    setStartAndEndTimes() {
      // 检查 edu 是否为空数组，避免执行空数组的 forEach
      if (this.formdata.edu && this.formdata.edu.length > 0) {
        this.formdata.edu.forEach(item => {
          item.start_time = item.time[0] || ''; // 防止 time 数组为空
          item.end_time = item.time[1] || '';   // 防止 time 数组为空
        });
      }

      // 检查 train 是否为空数组，避免执行空数组的 forEach
      if (this.formdata.train && this.formdata.train.length > 0) {
        this.formdata.train.forEach(item => {
          item.start_time = item.time[0] || ''; // 防止 time 数组为空
          item.end_time = item.time[1] || '';   // 防止 time 数组为空
        });
      }
    },

    handleRes() {
      this.formdata = this.removeShowOneData(this.formdata)
      this.setStartAndEndTimes()
      if(this.branch_ids.length>0){
        this.formdata.branch_ids  = this.branch_ids.join(',')
      }else{
        this.formdata.branch_ids = ''
      }
      console.log(this.branch_ids)
      registerUser(this.formdata).then(res => {
        if (res.code === 200) {
          this.tabactive = 3
        } else {
          this.$message.error(res.msg)
        }
      })

    }
  }
}
</script>

<template>
  <div class="ljl-register">
    <div class="ljl-bg">
      <img class="ljl-bg-login" src="@/assets/image/login/login.png">
      <div class="ljl-bg-header"></div>
      <div class="ljl-bg-content">
        <div class="ljl-bg-content-title">欢迎注册 · 滨航统一门户</div>
        <div class="ljl-bg-item">
          <div class="ljl-bg-item-header">
            <div class="ljl-bg-item-header-w" @click="goFH()">
              <local-svg iconClass="back" class="ljl-bg-item-header-icon"></local-svg>
              <sapn class="ljl-bg-item-header-text">返回登录</sapn>
            </div>
          </div>
          <div class="ljl-bg-item-tab" v-if="tabactive !==3">
            <div class="ljl-bg-item-tab-list">
              <div v-for="(item,index) in tablist" :key="index" class="ljl-bg-item-tab-list-public"
                   :class="tabactive===item.id?'ljl-bg-item-tab-list-active':''">{{ item.name }}
              </div>
            </div>
          </div>
          <div class="ljl-re" v-if="tabactive===1">
            <div class="ljl-re-form">
              <div class="ljl-re-form-item">
                <div class="ljl-re-form-item-header">用户名<span class="red">*</span></div>
                <el-input v-model="formdata.name" placeholder="请输入用户名" size="small"></el-input>
              </div>
              <div class="ljl-re-form-item">
                <div class="ljl-re-form-item-header">手机号<span class="red">*</span></div>
                <el-input v-model="formdata.mobile" placeholder="请输入手机号" size="small"></el-input>
              </div>
              <div class="ljl-re-form-item">
                <div class="ljl-re-form-item-header">电子邮箱<span class="red">*</span></div>
                <el-input v-model="formdata.email" placeholder="请输入电子邮箱" size="small"></el-input>
              </div>
              <div class="ljl-re-form-item">
                <div class="ljl-re-form-item-header">所属部门</div>
                <el-cascader :options="options" v-model="branch_ids" :props="{value:'id', multiple: true,checkStrictly: true,emitPath:false}"
                             :show-all-levels="false" placeholder="请选择所属部门" size="small" filterable
                             clearable></el-cascader>
              </div>
            </div>
            <div class="ljl-re-but-w">
              <div class="ljl-re-but" @click="tabactivenext">下一步</div>
            </div>
          </div>
          <div class="ljl-portrait" v-if="tabactive===2">
            <div class="ljl-portrait-remak">
              注：员工画像为非必填信息，可点击 “<span class="text" @click="goReg('dibu')">跳过</span>” 直接进行提交注册
            </div>
            <div class="ljl-portrait-title">
              <svg-icon icon-class="huaxiang" class="icon"></svg-icon>
              员工画像
            </div>
            <div class="ljl-portrait-cont">
              <div class="ljl-portrait-left">
                <div class="ljl-portrait-left-item" :class="item.isActive?'ljl-portrait-left-item-active':''"
                     v-for="(item,index) in lefttab" :key="index" @click="goReg(item.md)">
                  <div class="yuan">
                    <div class="nyuan"></div>
                  </div>
                  <div class="text">{{ item.name }}</div>
                </div>
              </div>
              <div class="ljl-portrait-right">
                <div class="right-item" v-for="(item,index) in lefttab" :key="index" :id="item.md">
                  <div class="right-item-title">
                    <div class="rleft" @click="itemShow(index)">
                      <span class="sj" :class="item.show?'':'sj-xz'"></span>{{ item.name }}
                    </div>
                    <div class="rright" v-if="index !== 0 && index !==1" @click="addPublic(index)">
                      <svg-icon icon-class="radd" class="icon"></svg-icon>
                      <span class="text">{{ item.add }}</span>
                    </div>
                  </div>
                  <div v-if="index === 0" class="right-item-content right-item-content-c1"
                       :class="item.show?'right-item-contentz':'right-item-contents'">
                    <div class="c1-item">
                      <div class="title">岗位名称</div>
                      <el-input v-model="formdata.job_info.job_name" clearable placeholder="请输入" size="small"
                                class="c1-item-width"></el-input>
                    </div>
                    <div class="c1-item">
                      <div class="title">岗位类别</div>
                      <el-select v-model="formdata.job_info.job_type" placeholder="请选择" size="small"
                                 class="c1-item-width" clearable>
                        <el-option v-for="(item,index) in JobList" :key="index" :value="item.id"
                                   :label="item.value"></el-option>
                      </el-select>
                    </div>
                    <div class="c1-item">
                      <div class="title">到岗日期</div>
                      <el-date-picker
                          v-model="formdata.job_info.come_time"
                          clearable
                          class="c1-item-width"
                          size="small"
                          value-format="yyyy-MM-dd"
                          type="date"
                          placeholder="选择日期">
                      </el-date-picker>
                    </div>
                    <div class="c1-item">
                      <div class="title">本年度假期</div>
                      <el-input v-model="formdata.job_info.annual_leave" clearable placeholder="请输入"
                                size="small" class="c1-item-width"></el-input>
                    </div>
                    <div class="c1-item">
                      <div class="title">累计工龄开始日期</div>
                      <el-date-picker
                          v-model="formdata.job_info.job_start_time"
                          clearable
                          class="c1-item-width"
                          size="small"
                          value-format="yyyy-MM-dd"
                          type="date"
                          placeholder="选择日期">
                      </el-date-picker>
                    </div>
                    <div class="c1-item">
                      <div class="title">参加工作时间</div>
                      <el-date-picker
                          v-model="formdata.job_info.start_work_time"
                          clearable
                          class="c1-item-width"
                          size="small"
                          value-format="yyyy-MM-dd"
                          type="date"
                          placeholder="选择日期">
                      </el-date-picker>
                    </div>
                    <div class="c1-item">
                      <div class="title">加入本企业时间</div>
                      <el-date-picker
                          clearable
                          v-model="formdata.job_info.in_company_time"
                          class="c1-item-width"
                          size="small"
                          value-format="yyyy-MM-dd"
                          type="date"
                          placeholder="选择日期">
                      </el-date-picker>
                    </div>

                  </div>
                  <div v-if="index === 1" class="right-item-content right-item-content-c2"
                       :class="item.show?'right-item-contentz':'right-item-contents'">
                    <div class="c1-item">
                      <div class="title">曾用名</div>
                      <el-input v-model="formdata.base_info.old_name" clearable placeholder="请输入" size="small"
                                class="c1-item-width"></el-input>
                    </div>
                    <div class="c1-item">
                      <div class="title">出生日期</div>
                      <el-date-picker
                          v-model="formdata.base_info.birthday"
                          clearable
                          class="c1-item-width"
                          size="small"
                          value-format="yyyy-MM-dd"
                          type="date"
                          placeholder="选择日期">
                      </el-date-picker>
                    </div>
                    <div class="c1-item">
                      <div class="title">性别</div>
                      <el-select v-model="formdata.base_info.sex" clearable placeholder="请选择" size="small"
                                 class="c1-item-width">
                        <el-option v-for="(item,index) in sexlist" :label='item.name' :value="item.id"
                                   :key="index"></el-option>
                      </el-select>
                    </div>
                    <div class="c1-item">
                      <div class="title">年龄</div>
                      <el-input v-model="formdata.base_info.age" clearable placeholder="请输入" size="small"
                                class="c1-item-width"></el-input>
                    </div>
                    <div class="c1-item">
                      <div class="title">民族</div>
                      <el-input v-model="formdata.base_info.nation" clearable placeholder="请输入" size="small"
                                class="c1-item-width"></el-input>
                    </div>
                    <div class="c1-item">
                      <div class="title">出生地</div>
                      <el-input v-model="formdata.base_info.birth_location" clearable placeholder="请输入" size="small"
                                class="c1-item-width"></el-input>
                    </div>
                    <div class="c1-item">
                      <div class="title">籍贯</div>
                      <el-input v-model="formdata.base_info.native_place" clearable placeholder="请输入" size="small"
                                class="c1-item-width"></el-input>
                    </div>
                    <div class="c1-item">
                      <div class="title">身份证/护照号</div>
                      <el-input v-model="formdata.base_info.card_num" clearable placeholder="请输入" size="small"
                                class="c1-item-width"></el-input>
                    </div>
                    <div class="c1-item">
                      <div class="title">现住址</div>
                      <el-input v-model="formdata.base_info.present_address" clearable placeholder="请输入" size="small"
                                class="c1-item-width"></el-input>
                    </div>
                    <div class="c1-item">
                      <div class="title">有效联系地址</div>
                      <el-input v-model="formdata.base_info.contact_address" clearable placeholder="请输入" size="small"
                                class="c1-item-width"></el-input>
                    </div>
                    <div class="c1-item">
                      <div class="title">现住址邮政编码</div>
                      <el-input v-model="formdata.base_info.present_address_code" clearable placeholder="请输入"
                                size="small" class="c1-item-width"></el-input>
                    </div>
                    <div class="c1-item">
                      <div class="title">有效地址邮政编码</div>
                      <el-input v-model="formdata.base_info.contact_address_code" clearable placeholder="请输入"
                                size="small" class="c1-item-width"></el-input>
                    </div>
                    <div class="c1-item" style="width: 100%">
                      <div class="title">户口地址</div>
                      <el-input v-model="formdata.base_info.residence" clearable placeholder="请输入" size="small"
                                class="c1-item-width"></el-input>
                    </div>
                    <div class="c1-item">
                      <div class="title zh zh-left">政治面貌</div>
                      <div class="c1-item-width"></div>
                    </div>
                    <div class="c1-item">
                      <div class="title zh zh-right">婚姻状态</div>
                      <div class="c1-item-width"></div>
                    </div>
                    <div class="c1-item">
                      <div class="title zh-left">政治面貌</div>
                      <el-input v-model="formdata.base_info.politics_status" clearable placeholder="请输入" size="small"
                                class="c1-item-width"></el-input>
                    </div>
                    <div class="c1-item">
                      <div class="title zh-right">婚姻状态</div>
                      <el-input v-model="formdata.base_info.marriage_status" clearable placeholder="请输入" size="small"
                                class="c1-item-width"></el-input>
                    </div>
                    <div class="c1-item">
                      <div class="title zh-left">加入时间</div>
                      <el-date-picker
                          v-model="formdata.base_info.politics_time"
                          clearable
                          class="c1-item-width"
                          size="small"
                          value-format="yyyy-MM-dd"
                          type="date"
                          placeholder="选择日期">
                      </el-date-picker>
                    </div>
                    <div class="c1-item">
                      <div class="title zh-right">婚姻登记时间</div>
                      <el-date-picker
                          v-model="formdata.base_info.marriage_time"
                          clearable
                          class="c1-item-width"
                          size="small"
                          value-format="yyyy-MM-dd"
                          type="date"
                          placeholder="选择日期">
                      </el-date-picker>
                    </div>
                    <div class="c1-item">
                      <div class="title zh-left">加入地点</div>
                      <el-input v-model="formdata.base_info.politics_location" clearable placeholder="请输入"
                                size="small" class="c1-item-width"></el-input>
                    </div>
                    <div class="c1-item">
                      <div class="title zh-right">子女数目</div>
                      <el-input v-model="formdata.base_info.childs_num" clearable placeholder="请输入" size="small"
                                class="c1-item-width"></el-input>
                    </div>
                    <div class="c1-item">
                      <div class="title zh-left">介绍人</div>
                      <el-input v-model="formdata.base_info.introducer" clearable placeholder="请输入" size="small"
                                class="c1-item-width"></el-input>
                    </div>
                  </div>
                  <div v-if="index === 2" class="right-item-content right-item-content-c3"
                       :class="item.show?'right-item-contentz':'right-item-contents'">
                    <el-table
                        tooltip-effect="light"
                        :data="formdata.family_info"
                        :header-cell-style="{ 'height': '56px','color':'#B0B1B9','background':'#FAFAFB'}"
                        :cell-style="{ height: '60px' }"
                        style="width: 100%;border-radius: 4px 4px 0px 0px">
                      <template slot="empty">
                        <el-empty :image-size="147" class="ljl-re-emp" :image="image" description='暂无数据'></el-empty>
                      </template>
                      <el-table-column width="10px">

                      </el-table-column>
                      <el-table-column
                          label="成员姓名"
                          min-width="100"
                          show-overflow-tooltip>
                        <template slot-scope="scope">
                          <el-input v-if="scope.row.show" size="small" v-model="scope.row.name"
                                    placeholder="请输入"></el-input>
                          <div v-else>{{ scope.row.name }}</div>
                        </template>
                      </el-table-column>
                      <el-table-column
                          label="与本人关系"
                          min-width="100" >
                        <template slot-scope="scope">
                          <el-input v-if="scope.row.show" size="small" v-model="scope.row.relation"
                                    placeholder="请输入"></el-input>
                          <div v-else>{{ scope.row.relation }}</div>
                        </template>
                      </el-table-column>
                      <el-table-column
                          label="性别"
                          min-width="100"
                          show-overflow-tooltip>
                        <template slot-scope="scope">
                          <el-select v-if="scope.row.show" v-model="scope.row.sex" clearable placeholder="请选择"
                                     size="small"
                                     class="c1-item-width">
                            <el-option v-for="(item,index) in sexlist" :label='item.name' :value="item.id"
                                       :key="index"></el-option>
                          </el-select>
                          <div v-else>{{ getNameById(scope.row.sex) }}</div>
                        </template>
                      </el-table-column>
                      <el-table-column
                          label="政治面貌"
                          min-width="100"
                          show-overflow-tooltip>
                        <template slot-scope="scope">
                          <el-input v-if="scope.row.show" size="small" v-model="scope.row.politics_status"
                                    placeholder="请输入"></el-input>
                          <div v-else>{{ scope.row.politics_status }}</div>
                        </template>
                      </el-table-column>
                      <el-table-column
                          label="婚否"
                          min-width="100"
                          show-overflow-tooltip>
                        <template slot-scope="scope">
                          <el-input v-if="scope.row.show" size="small" v-model="scope.row.marriage_status"
                                    placeholder="请输入"></el-input>
                          <div v-else>{{ scope.row.marriage_status }}</div>
                        </template>
                      </el-table-column>
                      <el-table-column
                          label="现工作单位"
                          min-width="100" show-overflow-tooltip>
                        <template slot-scope="scope">
                          <el-input v-if="scope.row.show" size="small" v-model="scope.row.work_unit"
                                    placeholder="请输入"></el-input>
                          <div v-else>{{ scope.row.work_unit }}</div>
                        </template>
                      </el-table-column>
                      <el-table-column
                          label="工作地址"
                          min-width="180"
                          show-overflow-tooltip>
                        <template slot-scope="scope">
                          <el-input v-if="scope.row.show" size="small" v-model="scope.row.work_location"
                                    placeholder="请输入"></el-input>
                          <div v-else>{{ scope.row.work_location }}</div>
                        </template>
                      </el-table-column>
                      <el-table-column
                          label="现职务"
                          min-width="100" show-overflow-tooltip>
                        <template slot-scope="scope">
                          <el-input v-if="scope.row.show" size="small" v-model="scope.row.job"
                                    placeholder="请输入"></el-input>
                          <div v-else>{{ scope.row.job }}</div>
                        </template>
                      </el-table-column>
                      <el-table-column
                          label="详细地址"
                          min-width="180"
                          show-overflow-tooltip>
                        <template slot-scope="scope">
                          <el-input v-if="scope.row.show" size="small" v-model="scope.row.location"
                                    placeholder="请输入"></el-input>
                          <div v-else>{{ scope.row.location }}</div>
                        </template>
                      </el-table-column>
                      <el-table-column
                          min-width="130"
                          label="邮编" show-overflow-tooltip>
                        <template slot-scope="scope">
                          <el-input v-if="scope.row.show" size="small" v-model="scope.row.post_code"
                                    placeholder="请输入"></el-input>
                          <div v-else>{{ scope.row.post_code }}</div>
                        </template>
                      </el-table-column>
                      <el-table-column
                          min-width="180"
                          label="联系电话" show-overflow-tooltip>
                        <template slot-scope="scope">
                          <el-input v-if="scope.row.show" size="small" v-model="scope.row.phone"
                                    placeholder="请输入"></el-input>
                          <div v-else>{{ scope.row.phone }}</div>
                        </template>
                      </el-table-column>
                      <el-table-column
                          label="操作" fixed="right" width="100">
                        <template slot-scope="scope">
                          <div class="ljl-re-tab-but">
                            <div v-if="!scope.row.show" @click="handletabedit('family_info',scope.$index)">编辑</div>
                            <div v-if="!scope.row.show" @click="handletabdel('family_info',scope.$index)">删除</div>
                            <div v-if="scope.row.show" @click="handletabsave('family_info',scope.$index)">确认</div>
                            <div v-if="scope.row.show" @click="handletabclose('family_info',scope.$index)">取消</div>
                          </div>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                  <div v-if="index === 3" class="right-item-content right-item-content-c3"
                       :class="item.show?'right-item-contentz':'right-item-contents'">
                    <el-table
                        tooltip-effect="light"
                        :data="formdata.emergency_contact"
                        :header-cell-style="{ 'height': '56px','color':'#B0B1B9','background':'#FAFAFB'}"
                        :cell-style="{ height: '60px' }"
                        style="width: 100%;border-radius: 4px 4px 0px 0px">
                      <template slot="empty">
                        <el-empty :image-size="147" class="ljl-re-emp" :image="image" description='暂无数据'></el-empty>
                      </template>
                      <el-table-column width="10px">

                      </el-table-column>
                      <el-table-column
                          min-width="224"
                          label="联系人"
                          show-overflow-tooltip>
                        <template slot-scope="scope">
                          <el-input v-if="scope.row.show" size="small" v-model="scope.row.contact_person"
                                    placeholder="请输入"></el-input>
                          <div v-else>{{ scope.row.contact_person }}</div>
                        </template>
                      </el-table-column>
                      <el-table-column
                          min-width="224"
                          label="与本人关系"
                          >
                        <template slot-scope="scope">
                          <el-input v-if="scope.row.show" size="small" v-model="scope.row.relation"
                                    placeholder="请输入"></el-input>
                          <div v-else>{{ scope.row.relation }}</div>
                        </template>
                      </el-table-column>
                      <el-table-column
                          min-width="224"
                          label="电话1"
                          show-overflow-tooltip>
                        <template slot-scope="scope">
                          <el-input v-if="scope.row.show" size="small" v-model="scope.row.phone_one"
                                    placeholder="请输入"></el-input>
                          <div v-else>{{ scope.row.phone_one }}</div>
                        </template>
                      </el-table-column>
                      <el-table-column
                          min-width="224"
                          label="电话2"
                          show-overflow-tooltip>
                        <template slot-scope="scope">
                          <el-input v-if="scope.row.show" size="small" v-model="scope.row.phone_two"
                                    placeholder="请输入"></el-input>
                          <div v-else>{{ scope.row.phone_two }}</div>
                        </template>
                      </el-table-column>
                      <el-table-column
                          label="操作" fixed="right" width="100">
                        <template slot-scope="scope">
                          <div class="ljl-re-tab-but">
                            <div v-if="!scope.row.show" @click="handletabedit('emergency_contact',scope.$index)">编辑
                            </div>
                            <div v-if="!scope.row.show" @click="handletabdel('emergency_contact',scope.$index)">删除
                            </div>
                            <div v-if="scope.row.show" @click="handletabsave('emergency_contact',scope.$index)">确认
                            </div>
                            <div v-if="scope.row.show" @click="handletabclose('emergency_contact',scope.$index)">取消
                            </div>
                          </div>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                  <div v-if="index === 4" class="right-item-content right-item-content-c3"
                       :class="item.show?'right-item-contentz':'right-item-contents'">
                    <el-table
                        tooltip-effect="light"
                        :data="formdata.edu"
                        :header-cell-style="{ 'height': '56px','color':'#B0B1B9','background':'#FAFAFB'}"
                        :cell-style="{ height: '60px' }"
                        style="width: 100%;border-radius: 4px 4px 0px 0px">
                      <template slot="empty">
                        <el-empty :image-size="147" class="ljl-re-emp" :image="image" description='暂无数据'></el-empty>
                      </template>
                      <el-table-column width="10px">

                      </el-table-column>
                      <el-table-column
                          min-width="100"
                          label="教育类型"
                          show-overflow-tooltip>
                        <template slot-scope="scope">
                          <el-input v-if="scope.row.show" size="small" v-model="scope.row.type"
                                    placeholder="请输入"></el-input>
                          <div v-else>{{ scope.row.type }}</div>
                        </template>
                      </el-table-column>
                      <el-table-column
                          min-width="100"
                          label="教育形式"
                          show-overflow-tooltip>
                        <template slot-scope="scope">
                          <el-input v-if="scope.row.show" size="small" v-model="scope.row.form"
                                    placeholder="请输入"></el-input>
                          <div v-else>{{ scope.row.form }}</div>
                        </template>
                      </el-table-column>
                      <el-table-column
                          width="280"
                          label="起始日期"
                          show-overflow-tooltip>
                        <template slot-scope="scope">
                          <el-date-picker
                              size="small"
                              class="ljl-re-pick"
                              v-if="scope.row.show"
                              v-model="scope.row.time"
                              value-format="yyyy-MM-dd"
                              clearable
                              placeholder="请选择"
                              type="daterange"
                              range-separator="至"
                              start-placeholder="开始日期"
                              end-placeholder="结束日期">
                          </el-date-picker>
                          <div v-else>{{
                              scope.row.time.length > 0 ? scope.row.time[0] + '~' + scope.row.time[1] : ''
                            }}
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column
                          min-width="100"
                          label="学校名称"
                          show-overflow-tooltip>
                        <template slot-scope="scope">
                          <el-input v-if="scope.row.show" size="small" v-model="scope.row.school"
                                    placeholder="请输入"></el-input>
                          <div v-else>{{ scope.row.school }}</div>
                        </template>
                      </el-table-column>
                      <el-table-column
                          min-width="100"
                          label="专业名称"
                          show-overflow-tooltip>
                        <template slot-scope="scope">
                          <el-input v-if="scope.row.show" size="small" v-model="scope.row.profession"
                                    placeholder="请输入"></el-input>
                          <div v-else>{{ scope.row.profession }}</div>
                        </template>
                      </el-table-column>
                      <el-table-column
                          min-width="100"
                          label="毕业类型"
                          show-overflow-tooltip>
                        <template slot-scope="scope">
                          <el-input v-if="scope.row.show" size="small" v-model="scope.row.finish_school"
                                    placeholder="请输入"></el-input>
                          <div v-else>{{ scope.row.finish_school }}</div>
                        </template>
                      </el-table-column>
                      <el-table-column
                          label="操作" fixed="right" width="100">
                        <template slot-scope="scope">
                          <div class="ljl-re-tab-but">
                            <div v-if="!scope.row.show" @click="handletabedit('edu',scope.$index)">编辑</div>
                            <div v-if="!scope.row.show" @click="handletabdel('edu',scope.$index)">删除</div>
                            <div v-if="scope.row.show" @click="handletabsave('edu',scope.$index)">确认</div>
                            <div v-if="scope.row.show" @click="handletabclose('edu',scope.$index)">取消</div>
                          </div>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                  <div v-if="index === 5" class="right-item-content right-item-content-c3"
                       :class="item.show?'right-item-contentz':'right-item-contents'">
                    <el-table
                        tooltip-effect="light"
                        :data="formdata.train"
                        :header-cell-style="{ 'height': '56px','color':'#B0B1B9','background':'#FAFAFB'}"
                        :cell-style="{ height: '60px' }"
                        style="width: 100%;border-radius: 4px 4px 0px 0px">
                      <template slot="empty">
                        <el-empty :image-size="147" class="ljl-re-emp" :image="image" description='暂无数据'></el-empty>
                      </template>
                      <el-table-column width="10px">

                      </el-table-column>
                      <el-table-column
                          min-width="100"
                          label="培训类型"
                          show-overflow-tooltip>
                        <template slot-scope="scope">
                          <el-input v-if="scope.row.show" size="small" v-model="scope.row.type"
                                    placeholder="请输入"></el-input>
                          <div v-else>{{ scope.row.type }}</div>
                        </template>
                      </el-table-column>
                      <el-table-column
                          min-width="100"
                          label="培训机构"
                          show-overflow-tooltip>
                        <template slot-scope="scope">
                          <el-input v-if="scope.row.show" size="small" v-model="scope.row.institution"
                                    placeholder="请输入"></el-input>
                          <div v-else>{{ scope.row.institution }}</div>
                        </template>
                      </el-table-column>
                      <el-table-column
                          min-width="180"
                          label="地点"
                          show-overflow-tooltip>
                        <template slot-scope="scope">
                          <el-input v-if="scope.row.show" size="small" v-model="scope.row.location"
                                    placeholder="请输入"></el-input>
                          <div v-else>{{ scope.row.location }}</div>
                        </template>
                      </el-table-column>
                      <el-table-column
                          width="280"
                          label="培训时间"
                          show-overflow-tooltip>
                        <template slot-scope="scope">
                          <el-date-picker
                              size="small"
                              class="ljl-re-pick"
                              v-if="scope.row.show"
                              v-model="scope.row.time"
                              value-format="yyyy-MM-dd"
                              clearable
                              placeholder="请选择"
                              type="daterange"
                              range-separator="至"
                              start-placeholder="开始日期"
                              end-placeholder="结束日期">
                          </el-date-picker>
                          <div v-else>{{
                              scope.row.time.length > 0 ? scope.row.time[0] + '~' + scope.row.time[1] : ''
                            }}
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column
                          min-width="100"
                          label="培训课程"
                          show-overflow-tooltip>
                        <template slot-scope="scope">
                          <el-input v-if="scope.row.show" size="small" v-model="scope.row.class"
                                    placeholder="请输入"></el-input>
                          <div v-else>{{ scope.row.class }}</div>
                        </template>
                      </el-table-column>
                      <el-table-column
                          min-width="100"
                          label="是否取证"
                          show-overflow-tooltip>
                        <template slot-scope="scope">
                          <el-input v-if="scope.row.show" size="small" v-model="scope.row.has_certificate"
                                    placeholder="请输入"></el-input>
                          <div v-else>{{ scope.row.has_certificate }}</div>
                        </template>
                      </el-table-column>
                      <el-table-column
                          min-width="100"
                          label="证书"
                          show-overflow-tooltip>
                        <template slot-scope="scope">
                          <el-input v-if="scope.row.show" size="small" v-model="scope.row.certificate"
                                    placeholder="请输入"></el-input>
                          <div v-else>{{ scope.row.certificate }}</div>
                        </template>
                      </el-table-column>
                      <el-table-column
                          min-width="100"
                          label="培训金额"
                          show-overflow-tooltip>
                        <template slot-scope="scope">
                          <el-input v-if="scope.row.show" size="small" v-model="scope.row.amount"
                                    placeholder="请输入"></el-input>
                          <div v-else>{{ scope.row.amount }}</div>
                        </template>
                      </el-table-column>
                      <el-table-column
                          min-width="100"
                          label="协议期限"
                          show-overflow-tooltip>
                        <template slot-scope="scope">
                          <el-input v-if="scope.row.show" size="small" v-model="scope.row.deadline"
                                    placeholder="请输入"></el-input>
                          <div v-else>{{ scope.row.deadline }}</div>
                        </template>
                      </el-table-column>
                      <el-table-column
                          label="操作" fixed="right" width="100">
                        <template slot-scope="scope">
                          <div class="ljl-re-tab-but">
                            <div v-if="!scope.row.show" @click="handletabedit('train',scope.$index)">编辑</div>
                            <div v-if="!scope.row.show" @click="handletabdel('train',scope.$index)">删除</div>
                            <div v-if="scope.row.show" @click="handletabsave('train',scope.$index)">确认</div>
                            <div v-if="scope.row.show" @click="handletabclose('train',scope.$index)">取消</div>
                          </div>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                  <div v-if="index === 6" class="right-item-content right-item-content-c3"
                       :class="item.show?'right-item-contentz':'right-item-contents'">
                    <el-table
                        tooltip-effect="light"
                        :data="formdata.job_title"
                        :header-cell-style="{ 'height': '56px','color':'#B0B1B9','background':'#FAFAFB'}"
                        :cell-style="{ height: '60px' }"
                        style="width: 100%;border-radius: 4px 4px 0px 0px">
                      <template slot="empty">
                        <el-empty :image-size="147" class="ljl-re-emp" :image="image" description='暂无数据'></el-empty>
                      </template>
                      <el-table-column width="10px">

                      </el-table-column>
                      <el-table-column
                          label="职业名称"
                          show-overflow-tooltip>
                        <template slot-scope="scope">
                          <el-input v-if="scope.row.show" size="small" v-model="scope.row.title"
                                    placeholder="请输入"></el-input>
                          <div v-else>{{ scope.row.title }}</div>
                        </template>
                      </el-table-column>
                      <el-table-column
                          show-overflow-tooltip>
                        <template slot="header">
                          职称系列
                        </template>
                        <template slot-scope="scope">
                          <el-input v-if="scope.row.show" size="small" v-model="scope.row.series"
                                    placeholder="请输入"></el-input>
                          <div v-else>{{ scope.row.series }}</div>
                        </template>
                      </el-table-column>
                      <el-table-column
                          label="职称等级"
                          show-overflow-tooltip>
                        <template slot-scope="scope">
                          <el-input v-if="scope.row.show" size="small" v-model="scope.row.level"
                                    placeholder="请输入"></el-input>
                          <div v-else>{{ scope.row.level }}</div>
                        </template>
                      </el-table-column>
                      <el-table-column
                          label="证书编号"
                          show-overflow-tooltip>
                        <template slot-scope="scope">
                          <el-input v-if="scope.row.show" size="small" v-model="scope.row.code_num"
                                    placeholder="请输入"></el-input>
                          <div v-else>{{ scope.row.code_num }}</div>
                        </template>
                      </el-table-column>
                      <el-table-column
                          label="生效时间"
                          width="250"
                          show-overflow-tooltip>
                        <template slot-scope="scope">
                          <el-date-picker
                              v-if="scope.row.show"
                              v-model="scope.row.effective_time"
                              type="date"
                              value-format="yyyy-MM-dd"
                              format="yyyy 年 MM 月 dd 日"
                              size="small"
                              class="ljl-re-pick"
                              placeholder="选择日期">
                          </el-date-picker>
                          <div v-else>{{ scope.row.effective_time }}</div>
                        </template>
                      </el-table-column>
                      <el-table-column
                          label="发证机关"
                          show-overflow-tooltip>
                        <template slot-scope="scope">
                          <el-input v-if="scope.row.show" size="small" v-model="scope.row.organ"
                                    placeholder="请输入"></el-input>
                          <div v-else>{{ scope.row.organ }}</div>
                        </template>
                      </el-table-column>
                      <el-table-column
                          label="操作" fixed="right" width="100">
                        <template slot-scope="scope">
                          <div class="ljl-re-tab-but">
                            <div v-if="!scope.row.show" @click="handletabedit('job_title',scope.$index)">编辑</div>
                            <div v-if="!scope.row.show" @click="handletabdel('job_title',scope.$index)">删除</div>
                            <div v-if="scope.row.show" @click="handletabsave('job_title',scope.$index)">确认</div>
                            <div v-if="scope.row.show" @click="handletabclose('job_title',scope.$index)">取消</div>
                          </div>
                        </template>
                      </el-table-column>
                    </el-table>
                    <div class="ljl-re-js">
                      <div class="ljl-re-js-left">职业资格信息</div>
                      <div class="ljl-re-js-right" @click="addworkin">
                        <svg-icon icon-class="radd" class="icon"></svg-icon>
                        <span class="text">添加职业资格信息</span>
                      </div>
                    </div>
                    <el-table
                        tooltip-effect="light"
                        :data="formdata.job_qualification"
                        :header-cell-style="{ 'height': '56px','color':'#B0B1B9','background':'#FAFAFB'}"
                        :cell-style="{ height: '60px' }"
                        style="width: 100%;border-radius: 4px 4px 0px 0px">
                      <template slot="empty">
                        <el-empty :image-size="147" class="ljl-re-emp" :image="image" description='暂无数据'></el-empty>
                      </template>
                      <el-table-column width="10px">

                      </el-table-column>
                      <el-table-column
                          label="职业资格名称"
                          min-width="100"
                          show-overflow-tooltip>
                        <template slot-scope="scope">
                          <el-input v-if="scope.row.show" size="small" v-model="scope.row.title"
                                    placeholder="请输入"></el-input>
                          <div v-else>{{ scope.row.title }}</div>
                        </template>
                      </el-table-column>
                      <el-table-column
                          label="职业资格等级"
                          min-width="100"
                          show-overflow-tooltip>
                        <template slot-scope="scope">
                          <el-input v-if="scope.row.show" size="small" v-model="scope.row.level"
                                    placeholder="请输入"></el-input>
                          <div v-else>{{ scope.row.level }}</div>
                        </template>
                      </el-table-column>
                      <el-table-column
                          label="证书编号"
                          show-overflow-tooltip>
                        <template slot-scope="scope">
                          <el-input v-if="scope.row.show" size="small" v-model="scope.row.code_num"
                                    placeholder="请输入"></el-input>
                          <div v-else>{{ scope.row.code_num }}</div>
                        </template>
                      </el-table-column>
                      <el-table-column
                          label="发证时间"
                          width="250"
                          show-overflow-tooltip>
                        <template slot-scope="scope">
                          <el-date-picker
                              v-if="scope.row.show"
                              v-model="scope.row.send_time"
                              type="date"
                              value-format="yyyy-MM-dd"
                              format="yyyy 年 MM 月 dd 日"
                              size="small"
                              class="ljl-re-pick"
                              placeholder="选择日期">
                          </el-date-picker>
                          <div v-else>{{ scope.row.send_time }}</div>
                        </template>
                      </el-table-column>
                      <el-table-column
                          label="发证机关"
                          show-overflow-tooltip>
                        <template slot-scope="scope">
                          <el-input v-if="scope.row.show" size="small" v-model="scope.row.send_organ"
                                    placeholder="请输入"></el-input>
                          <div v-else>{{ scope.row.send_organ }}</div>
                        </template>
                      </el-table-column>
                      <el-table-column
                          width="250"
                          label="有效截止时间"
                          show-overflow-tooltip>
                        <template slot-scope="scope">
                          <el-date-picker
                              v-if="scope.row.show"
                              v-model="scope.row.end_time"
                              type="date"
                              value-format="yyyy-MM-dd"
                              format="yyyy 年 MM 月 dd 日"
                              size="small"
                              class="ljl-re-pick"
                              placeholder="选择日期">
                          </el-date-picker>
                          <div v-else>{{ scope.row.end_time }}</div>
                        </template>
                      </el-table-column>
                      <el-table-column
                          label="操作" fixed="right" width="100">
                        <template slot-scope="scope">
                          <div class="ljl-re-tab-but">
                            <div v-if="!scope.row.show" @click="handletabedit('job_qualification',scope.$index)">编辑
                            </div>
                            <div v-if="!scope.row.show" @click="handletabdel('job_qualification',scope.$index)">删除
                            </div>
                            <div v-if="scope.row.show" @click="handletabsave('job_qualification',scope.$index)">确认
                            </div>
                            <div v-if="scope.row.show" @click="handletabclose('job_qualification',scope.$index)">取消
                            </div>
                          </div>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                  <div v-if="index === 7" class="right-item-content right-item-content-c4"
                       :class="item.show?'right-item-contentz':'right-item-contents'">
                    <div class="c4-time-list" v-for="(item,index) in formdata.work_info" :key="index">
                      <img class="c4-time-list-img" src="@/assets/image/login/time.png"/>
                      <div class="c4-time-header">
                        <span class="text">{{ item.start_time }}至 {{ item.end_time }}</span>
                        <svg-icon icon-class="redit" class="icon" @click.native="editWork(index,item)"></svg-icon>
                      </div>
                      <div class="c4-time-content">
                        <div class="c4-time-content-item">
                          <svg-icon icon-class="gw" style="font-size: 14px" class="icon"></svg-icon>
                          <div class="text">{{ item.start_job ? item.start_job : '-' }}</div>
                        </div>
                        <div class="c4-time-content-item">
                          <svg-icon icon-class="gw" style="font-size: 14px" class="icon"></svg-icon>
                          <div class="text">{{ item.end_job ? item.end_job : '-' }}</div>
                        </div>
                        <div class="c4-time-content-item">
                          <svg-icon icon-class="gsname" style="font-size: 14px" class="icon"></svg-icon>
                          <div class="text">{{ item.title ? item.title : '-' }}</div>
                        </div>
                        <div class="c4-time-content-item">
                          <svg-icon icon-class="gshy" style="font-size: 14px" class="icon"></svg-icon>
                          <div class="text">{{ item.trade ? item.trade : '-' }}</div>
                        </div>
                        <div class="c4-time-content-item">
                          <svg-icon icon-class="gsdz" style="font-size: 14px" class="icon"></svg-icon>
                          <div class="text">{{ item.location ? item.location : '-' }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="ljl-re-hua-but" id="dibu">
              <div class="ljl-re-hua-but-next" @click="tabactive=1">上一步</div>
              <div class="ljl-re-hua-but-re" @click="handleRes">提交注册</div>
            </div>
          </div>
          <div class="ljl-save" v-if="tabactive===3">
            <img class="ljl-save-head" src="@/assets/image/login/save.png">
            <div class="ljl-save-title">提交成功</div>
            <div class="ljl-save-text">将会在三个工作日内完成审核，审核完成后您将收到邮件通知</div>
            <div class="ljl-save-text">若有问题请联系<span class="blue">13920604605</span>咨询</div>
            <div @click="goFH()" class="ljl-save-but">返回登录页</div>
          </div>
        </div>
      </div>
    </div>
    <addview v-if="WorkShow" @close="WorkShow=false" @save="WorkSave" :workform="work_form"></addview>
  </div>
</template>

<style scoped lang="scss">
.ljl-register {
  width: 100%;
  height: 100vh;
  background: #F0F3FA;

  .ljl-bg {
    background-image: url("@/assets/image/login/bg_d.png");
    background-size: 100% 280px;
    background-repeat: no-repeat;
    background-position: left top;
    background-color: #F0F3FA;
    min-height: 280px;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;

    .ljl-bg-login {
      position: absolute;
      width: 190px;
      height: 40px;
      top: 40px;
      left: 60px;
    }

    .ljl-bg-header {
      background-image: url("@/assets/image/login/bg.png");
      height: 280px;
      width: 100%;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center center;
    }

    .ljl-bg-content {
      width: 1320px;
      margin-top: -159px;

      .ljl-bg-content-title {
        margin-bottom: 57px;
        font-family: Microsoft YaHei UI, Microsoft YaHei UI;
        font-weight: 400;
        font-size: 36px;
        color: #1A6BFF;
        line-height: 36px;
        text-align: left;
        font-style: normal;
        text-transform: none;
      }

      .ljl-bg-item {
        background: #FFFFFF;
        border-radius: 6px 6px 6px 6px;
        padding: 0px 60px 66px 60px;
        box-sizing: border-box;

        .ljl-bg-item-header {
          height: 64px;
          display: flex;
          align-items: flex-end;
          box-sizing: border-box;
          padding-bottom: 16px;
          border-bottom: 1px solid #e9ebf9;

          .ljl-bg-item-header-w {
            cursor: pointer;

            .ljl-bg-item-header-icon {
              margin-right: 14px;
              font-size: 20px;
              color: #0D347A;
            }

            .ljl-bg-item-header-text {
              font-family: Microsoft YaHei UI, Microsoft YaHei UI;
              font-weight: 400;
              font-size: 16px;
              color: #0D347A;
              line-height: 16px;
            }
          }

          .ljl-bg-item-header-w:hover {
            .ljl-bg-item-header-icon {
              color: #1D78FE;
            }

            .ljl-bg-item-header-text {
              color: #1D78FE;
            }
          }

        }

        .ljl-bg-item-tab {
          display: flex;
          justify-content: center;
          margin-top: 30px;

          .ljl-bg-item-tab-list {
            width: 241px;
            height: 48px;
            background: #F4F7FF;
            border-radius: 24px 24px 24px 24px;
            border: 1px solid #CDDCF4;
            display: flex;
            align-items: center;
            justify-content: center;

            .ljl-bg-item-tab-list-public {
              width: 117px;
              height: 40px;
              border-radius: 20px 20px 20px 20px;
              display: flex;
              align-items: center;
              justify-content: center;
              font-family: Microsoft YaHei, Microsoft YaHei;
              font-weight: 400;
              font-size: 14px;
              color: #627DA6;
            }

            .ljl-bg-item-tab-list-active {
              background: #1D78FE;
              color: white;
            }
          }
        }
      }
    }
  }
}

.ljl-re {
  margin-top: 40px;

  .ljl-re-but-w {
    display: flex;
    justify-content: center;
    margin-top: 70px;

    .ljl-re-but {
      width: 240px;
      height: 48px;
      background: #1A6BFF;
      border-radius: 24px 24px 24px 24px;
      font-family: Microsoft YaHei UI, Microsoft YaHei UI;
      font-weight: 400;
      font-size: 16px;
      color: #FFFFFF;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }

    .ljl-re-but:hover {
      background: #1D78FE;
    }
  }

  .ljl-re-form {
    display: flex;
    flex-direction: column;
    gap: 24px;

    .ljl-re-form-item {
      display: flex;
      flex-direction: column;
      gap: 16px;

      .ljl-re-form-item-header {
        font-family: Microsoft YaHei UI, Microsoft YaHei UI;
        font-weight: bold;
        font-size: 14px;
        color: #3E4A60;
        line-height: 14px;

        .red {
          color: #FF3D3D;
        }
      }
    }
  }

}

.ljl-portrait {
  margin-top: 30px;

  .ljl-portrait-remak {
    display: flex;
    justify-content: center;
    font-family: Microsoft YaHei UI, Microsoft YaHei UI;
    font-weight: 400;
    font-size: 14px;
    color: #B0B1B9;
    line-height: 14px;

    .text {
      cursor: pointer;
      color: #1A6BFF;
    }

    .text:hover {
      color: #1D78FE;
    }
  }

  .ljl-portrait-title {
    display: flex;
    align-items: center;
    font-family: Microsoft YaHei UI, Microsoft YaHei UI;
    font-weight: bold;
    font-size: 16px;
    color: #3E4A60;
    line-height: 32px;
    text-align: left;
    font-style: normal;
    text-transform: none;

    .icon {
      font-size: 32px;
      margin-right: 6px;
    }
  }

  .ljl-portrait-cont {
    display: flex;
    justify-content: space-between;
    position: relative;
    //height: 2000px;
    .ljl-portrait-left {
      position: sticky;
      top: 32px;
      margin-top: 32px;
      align-self: flex-start; /* 让左侧元素顶端对齐 */
      margin-left: 8px;

      .ljl-portrait-left-item {
        border-left: 1px solid #E9EBF9;
        height: 47px;
        position: relative;
        cursor: pointer;

        .yuan {
          position: absolute;
          width: 13px;
          height: 13px;
          border-radius: 100%;
          border: 1px solid #DAE6FF;
          display: flex;
          align-items: center;
          justify-content: center;
          top: -6px;
          left: -8px;

          .nyuan {
            width: 9px;
            height: 9px;
            border-radius: 100%;
            background: #FFFFFF;
          }
        }

        .text {
          font-family: Microsoft YaHei, Microsoft YaHei;
          font-weight: bold;
          font-size: 14px;
          color: #A9B2C5;
          line-height: 16px;
          white-space: nowrap;
          word-break: keep-all;
          left: 20px;
          top: -6px;
          position: absolute;
        }
      }

      .ljl-portrait-left-item:last-child {
        border-left: none !important;
      }

      .ljl-portrait-left-item:hover {
        .yuan {
          border: 1px solid #B6CFFF;

          .nyuan {
            background: #1A6BFF;
          }
        }

        .text {
          color: #1A6BFF;
        }
      }

      .ljl-portrait-left-item-active {
        .yuan {
          border: 1px solid #B6CFFF;

          .nyuan {
            background: #1A6BFF;
          }
        }

        .text {
          color: #1A6BFF;
        }
      }

    }

    .ljl-portrait-right {
      //padding-left: 200px;
      width: 1000px;
      flex: 0 0 auto;
      display: flex;
      flex-direction: column;
      gap: 40px;

      .right-item {

        .right-item-title {
          height: 40px;
          background: #EAF1FF;
          border-radius: 20px 20px 20px 20px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          box-sizing: border-box;
          padding: 0px 36px 0px 32px;

          .rleft {
            display: flex;
            align-items: center;
            cursor: pointer;

            .sj {
              width: 0;
              height: 0;
              border-left: 6px solid transparent;
              border-right: 6px solid transparent;
              border-top: 8px solid #A1B6DD; /* 设置底边颜色来显示三角形 */
              margin-right: 10px;
              transform: rotate(0deg);
              transition: transform 0.3s ease; /* 添加过渡动画 */
            }

            .sj-xz {
              transform: rotate(-90deg)
            }
          }

          .rright {
            display: flex;
            align-items: center;
            cursor: pointer;

            .icon {
              margin-right: 8px;
              font-size: 14px;
              color: #475B93;
            }

            .text {
              font-family: Microsoft YaHei UI, Microsoft YaHei UI;
              font-weight: bold;
              font-size: 14px;
              color: #475B93;
              line-height: 14px;
            }
          }

          .rright:hover {
            .icon {
              color: #1D78FE;
            }

            .text {
              color: #1D78FE;
            }
          }

        }

        .right-item-content {
          overflow: hidden;

        }

        .right-item-contentz {
          max-height: 99999px;
          margin-top: 40px;
        }

        .right-item-contents {
          max-height: 0px;
        }

        .right-item-content-c1 {
          display: flex;
          flex-wrap: wrap;
          row-gap: 12px;
          column-gap: 63px;
          box-sizing: border-box;
          padding: 0px 60px 0px 49px;

          .c1-item:nth-child(n) {
            .title {
              width: 112px;
            }
          }

          .c1-item:nth-child(2n) {
            .title {
              width: 84px;
            }
          }
        }

        .right-item-content-c2 {
          display: flex;
          flex-wrap: wrap;
          row-gap: 12px;
          column-gap: 35px;
          box-sizing: border-box;
          padding: 0px 60px 0px 49px;

          .c1-item:nth-child(n) {
            .title {
              width: 98px;
            }
          }

          .c1-item:nth-child(2n) {
            .title {
              width: 112px;
            }
          }
        }
      }
    }
  }
}

.c1-item {
  display: flex;
  align-items: center;

  .title {
    word-break: keep-all;
    white-space: nowrap;
    margin-right: 16px;
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 400;
    font-size: 14px;
    color: #3E4A60;
    text-align: right;
  }

  .zh {
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: bold;
    font-size: 14px;
    color: #3E4A60;
    line-height: 14px;
    margin-top: 18px;
    margin-bottom: 15px;
  }

  .zh-left {
    width: 98px !important;
  }

  .zh-right {
    width: 112px !important;
  }

  .c1-item-width {
    width: 300px;
  }
}

:deep(.c1-item-width) {
  .el-input__inner {
    border-radius: 6px;
  }
}

:deep(.ljl-re-emp) {
  .el-empty__description {
    margin-top: -30px;
  }
}

.ljl-re-js {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 36px 0px 21px;
  box-sizing: border-box;
  margin-top: 30px;
  margin-bottom: 20px;

  .ljl-re-js-left {
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: bold;
    font-size: 14px;
    color: #60656E;
    line-height: 14px;
  }

  .ljl-re-js-right {
    display: flex;
    align-items: center;
    cursor: pointer;
    color: #475B93;

    .icon {
      margin-right: 8px;
      font-size: 14px;
    }

    .text {
      font-family: Microsoft YaHei UI, Microsoft YaHei UI;
      font-weight: bold;
      font-size: 14px;
      line-height: 14px;
    }
  }

  .ljl-re-js-right:hover {
    color: #1D78FE;

  }

}

.c4-time-list {
  margin-left: 8px;
  margin-top: 8px;
  height: 72px;
  border-left: 1px solid #EEF1F5;
  position: relative;
  box-sizing: border-box;
  padding: 0px 24px;

  .c4-time-list-img {
    position: absolute;
    width: 16px;
    height: 16px;
    top: -8px;
    left: -8px;
  }

  .c4-time-header {
    position: absolute;
    top: -6px;
    display: flex;
    align-items: center;

    .text {
      font-family: Microsoft YaHei UI, Microsoft YaHei UI;
      font-weight: bold;
      font-size: 14px;
      color: #474952;
      line-height: 14px;
      margin-right: 20px;
    }

    .icon {
      cursor: pointer;
      font-size: 14px;
      color: #315496;
    }

    .icon:hover {
      color: #1D78FE;
    }
  }

  .c4-time-content {
    position: absolute;
    display: flex;
    align-items: center;
    column-gap: 30px;
    top: 24px;

    .c4-time-content-item {
      display: flex;
      align-items: center;

      .icon {
        margin-right: 8px;
      }

      .text {
        font-family: Microsoft YaHei UI, Microsoft YaHei UI;
        font-weight: 400;
        font-size: 14px;
        color: #60656E;
        line-height: 14px;
      }
    }
  }
}

.right-item-content-c4 {
  .c4-time-list:last-child {
    border-left: none !important;
  }
}

.ljl-re-hua-but {
  display: flex;
  align-items: center;
  justify-content: center;
  column-gap: 30px;

  .ljl-re-hua-but-next {
    width: 240px;
    height: 48px;
    background: #DFECFF;
    border-radius: 24px;
    border: 1px solid #A1C7FF;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: Microsoft YaHei UI, Microsoft YaHei UI;
    font-weight: 400;
    font-size: 16px;
    color: #1A6BFF;
    cursor: pointer;
  }

  .ljl-re-hua-but-next:hover {
    border: 1px solid #1A6BFF;
  }

  .ljl-re-hua-but-re {
    width: 240px;
    height: 48px;
    background: #1A6BFF;
    border-radius: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: Microsoft YaHei UI, Microsoft YaHei UI;
    font-weight: 400;
    font-size: 16px;
    color: #FFFFFF;
    line-height: 20px;
    cursor: pointer;
  }

  .ljl-re-hua-but-re:hover {
    background: #1D78FE;
  }
}

.ljl-save {
  display: flex;
  align-items: center;
  flex-direction: column;

  .ljl-save-head {
    margin-top: 135px;
    width: 160px;
  }

  .ljl-save-title {
    font-family: Microsoft YaHei UI, Microsoft YaHei UI;
    font-weight: 400;
    font-size: 20px;
    color: #293854;
    line-height: 36px;
  }

  .ljl-save-text {
    font-family: Microsoft YaHei UI, Microsoft YaHei UI;
    font-weight: 400;
    font-size: 16px;
    color: #888DAE;
    line-height: 36px;

    .blue {
      color: #1D78FE;
      text-decoration: underline;
      text-underline-offset: 4px; /* 调整下划线与文字之间的距离 */
    }
  }

  .ljl-save-but {
    margin-top: 125px;
    margin-bottom: 109px;
    width: 240px;
    height: 48px;
    background: #1A6BFF;
    border-radius: 24px;
    font-family: Microsoft YaHei UI, Microsoft YaHei UI;
    font-weight: 400;
    font-size: 16px;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }

  .ljl-save-but:hover {
    background: #1D78FE;
  }
}

.ljl-re-tab-but {
  display: flex;
  align-items: center;
  column-gap: 20px;

  div {
    font-size: 14px;
    color: #37578F;
    cursor: pointer;
    word-break: keep-all;
    white-space: nowrap;

  }

  div:hover {
    color: #1D78FE;
  }
}

:deep(.ljl-re-pick .el-range-separator) {
  line-height: 32px !important;
}

:deep(.ljl-re-pick .el-range__close-icon) {
  line-height: 32px !important;
}

</style>
<style>
.right-item-content-c3 .el-table::before {
  border-bottom: none !important;
}

</style>
